import styled from 'styled-components';

export default styled.div`
  && {
    background-color: #c1e18d;
    .box {
      cursor: pointer;
      margin-left: 35px;
      :hover {
        background-color: white;
        border: 1px solid #ff8a00;
        .text {
          color: rgba(235, 164, 80, 1);
        }
        .icon {
          color: rgba(235, 164, 80, 1);
        }
      }
      width: 246px;
      display: flex;
      background-color: #ff8a00;
      align-items: center;
      border: 1px solid #ff8a00;
      .text {
        padding-top: 4px;
        padding-bottom: 3px;
        color: white;
      }
      .icon {
        color: white;
        margin-right: 20px;
        margin-left: 7px;
      }
    }
  }
`;
